import { render } from "./Recibo.vue?vue&type=template&id=4817686a"
import script from "./Recibo.vue?vue&type=script&lang=js"
export * from "./Recibo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
